module.exports = __webpack_public_path__ + "static/media/bservo.8b38e5a3.svg";